export default "__VITE_ASSET__CMG7FRj7__"